import { deleteAppModule } from "../api/appModuleService";

export const useDeleteModule = (successCallback) => {
    const removeModule = async (id) => {
        try {
          await deleteAppModule(id);
          if (successCallback) successCallback();
        } catch (error) {
            console.error("Failed to delete app module:", error);
            throw error;
        }
    };

    return { removeModule };
};